import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { Facet } from '../types/facet';

export function getFacetTagCategoryTrackingProperty({
    filter,
}: PickDomain<Facet, 'filter'>): string {
    return filter.name;
}
